import { Box, Card, Typography } from 'components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getCookie, setCookie } from '../../utilities/cookies';
import { Button } from '../_form';

const Wrapper = styled(Card).attrs({ width: 'auto' })`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 40px;
  right: 20px;
  padding: 10px;
  border: 2px solid ${({ theme }) => theme.palette.neutral.mainBlue};
`;

export const Cookies = () => {
  const { t } = useTranslation();
  const acceptCookies = getCookie('acceptCookies');
  const [accepted, setAccepted] = useState<boolean>(!!acceptCookies);
  if (accepted) return <></>;

  return (
    <Wrapper>
      <Typography.P variant="body" color="dark">
        {t('common.cookiesMessage').split('\n').map((l, idx) => (
          <React.Fragment key={idx}>
            {l}<br/>
          </React.Fragment>
        ))}
      </Typography.P>
      <Box ml={3}>
        <Button
          onClick={() => {
            setCookie('acceptCookies', 'true', 3600);
            setAccepted(true);
          }}
        >
          OK
        </Button>
      </Box>
    </Wrapper>
  );
};
